import './Posts.css';
import { PostGrid } from '../../components/PostGrid/PostGrid.js';
import { useEffect, useState } from 'react';
import sanityClient from '../../sanityClient.js';
import { postsQuery } from '../../queries/postQuery.js';
import { StandardLayout } from '../../layouts/StandardLayout.js';

export default function Posts(){
    const [postData, setPostData] = useState(null);

    useEffect(() => {
        sanityClient.fetch(postsQuery)
        .then((data) => setPostData(data))
        .catch(console.error)
    }, [])

    let content = null;
    if(postData){
        content = <PostGrid posts={postData} />
    } else{
        content = "Loading..."
    }

    return(
        <StandardLayout title={"all posts"} content={content} />
    )
}
